import styled from "styled-components";

export const SectionWrap = styled.div`
  padding-top: 20px;
  padding-bottom: 0px;
`;
